import FilterContext from '@jetshop/core/components/Filters/FilterContext';
import React from 'react';
import stripCategoryId from '@jetshop/core/components/Filters/utils/stripCategoryId';
const RangeFiltersBehaviour = ({ filters, children }) => {
    const rangeFilters = filters.filter(filter => filter.__typename === 'NumericRangeFilter');
    if (rangeFilters.length < 1)
        return null;
    return (React.createElement(FilterContext.Consumer, null, filterProps => 
    // Map over all the range filters
    rangeFilters.map(filter => {
        // Check if this filter is an active one
        const activeFilter = filterProps.activeFilters.rangeFilters.find(item => item.id === stripCategoryId(filter.id));
        let selectedVals = null;
        if (activeFilter) {
            // Make sure the selected min/max are never lower or higher than
            // the available min/max respectively.
            selectedVals = [
                Math.max(activeFilter.min, filter.min),
                Math.min(activeFilter.max, filter.max)
            ];
        }
        return (React.createElement(React.Fragment, { key: filter.id }, children({ selectedVals, filterProps, filter })));
    })));
};
export default RangeFiltersBehaviour;
//# sourceMappingURL=RangeFiltersBehaviour.js.map